import React, { useState, useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { LoadingPanel } from "../../LoadingPanel";
import { addNotificationWithTimeout } from '../../../app/addNotificationWithTimeout';
import { handleResponse } from '../../../app/handleResponse';
import { getCSRFToken } from '../../../app/getCSRFToken';
import { useDisableNumberInputScroll } from '../../../app/useDisableNumberInputScroll';
import {
    Grid,
    GridColumn as Column,
} from "@progress/kendo-react-grid";
import { Button } from "@progress/kendo-react-buttons";
import { Form, Field, FormElement } from "@progress/kendo-react-form";
import { Checkbox, Input, NumericTextBox } from "@progress/kendo-react-inputs";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { Dialog } from "@progress/kendo-react-dialogs";
import { AdministratorVenueEventAlerts } from "../venueeventalert/VenueEventAlerts";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import { GetNextSaturday } from '../../../app/DateFunctions';


import {
    FormDateRangePicker,
    FormDropDownList,
    FormAutoComplete,
    FormCheckbox,
    FormInput
} from "../../forms/form-components";

import './Report.scss';

export const AdministratorEventsNotShorted = () => {
    //Use the custom hook to disable scrolling in number inputs
    useDisableNumberInputScroll();

    const dispatch = useDispatch();

    const formReference = useRef(null);

    const defaultQuantity = 4;

    const defaultTicketingWebsite = {
        ticketingWebsiteId: "",
        name: "All Websites",
    };
    const defaultVenueEventStatusType = {
        venueEventStatusTypeId: "",
        name: "All Statuses",
    };
    const quantities = [
        { name: "Quantity", value: 0 },
        { name: "1", value: 1 },
        { name: "2", value: 2 },
        { name: "3", value: 3 },
        { name: "4", value: 4 },
        { name: "5", value: 5 },
        { name: "6", value: 6 },
        { name: "7", value: 7 },
        { name: "8", value: 8 },
        { name: "9", value: 9 },
        { name: "10", value: 10 },
        { name: "11", value: 11 },
        { name: "12", value: 12 },
    ];

    const [eventsNotShorted, setEventsNotShorted] = useState(undefined);
    const [eventsNotShortedCount, setEventsNotShortedCount] = useState(0);
    const [skipCount, setSkipCount] = useState(0);
    const [itemsPerPage, setItemsPerPage] = useState(1);
    const [areEventsNotShortedLoading, setAreEventsNotShortedLoading] = useState(false);
    const [reportId, setReportId] = useState(undefined);
    const [ticketingWebsites, setTicketingWebsites] = useState([]);
    const [venueEventStatusTypes, setVenueEventStatusTypes] = useState([]);
    const [searchCriteria, setSearchCriteria] = useState(undefined);
    const [venues, setVenues] = useState([]);
    const [venueName, setVenueName] = useState(undefined);
    const [areVenuesLoading, setAreVenuesLoading] = useState(false);
    const [isHeaderCheckboxChecked, setIsHeaderCheckboxChecked] = useState(false);
    const [selectedQuantity, setSelectedQuantity] = useState(quantities[defaultQuantity]);
    const [enteredSectionName, setEnteredSectionName] = useState("GA");
    const [enteredLowSeatNumber, setEnteredLowSeatNumber] = useState(undefined);
    const [focusElementClassName, setFocusElementClassName] = useState(undefined);
    const [lastSelectedVenueEventKey, setLastSelectedVenueEventKey] = useState(undefined);
    const [selectedStopHidingDate, setSelectedStopHidingDate] = useState(undefined);

    const autocompleteTimeout = useRef();
    const timeoutDelay = 500; //Milliseconds
    
    const [showTicketTypes, setShowTicketTypes] = useState(false);
    const [ticketTypes, setTicketTypes] = useState(undefined);

    const [showEventAlerts, setShowEventAlerts] = useState(false);
    const [alertsEventKey, setAlertsEventKey] = useState(undefined);
    const [alertsTicketingWebsiteId, setAlertsTicketingWebsiteId] = useState(undefined);

    const SelectedCell = (props) => {
        const venueEventKey = props.dataItem.venueEventKey;
        const selected = props.dataItem.selected;

        return (
            <td className="text-center">
                <Checkbox onChange={(event) => selectedValueChanged(event, venueEventKey, !selected)} value={selected} />
            </td>
        );
    };

    const SelectedHeaderCell = () => {
        return (
            <div className="text-center">
                <Checkbox onChange={headerCheckboxValueChanged} value={isHeaderCheckboxChecked} />
            </div>
        );
    };

    const ViewUrlHeaderCell = () => {
        return (
            <div>
                <Button type={"button"} fillMode="link" title="View Selected Websites" onClick={viewSelectedUrls} className="p-0">
                    View Selected
                </Button>
            </div>
        );
    };

    const ViewUrlCell = (props) => {  
        const url = props.dataItem[props.field];     

        return (
            <td className={"text-nowrap"}>
                {url ? <Link to={{ pathname: url }} target={"_blank"} rel={"noopener noreferrer"}>View Website</Link> : ""}
            </td>
        );
    };

    const SectionNameCell = (props) => {
        const venueEventKey = props.dataItem.venueEventKey;
        const ticketingWebsiteId = props.dataItem.ticketingWebsiteId;
        const sectionName = props.dataItem.sectionName;    
        const eventTicketTypes = props.dataItem.ticketTypes;

        return (
            <td>
                <Input 
                    onChange={(event) => eventSectionNameChanged(venueEventKey, event.value)}
                    value={sectionName}
                    style={{ width: "130px" }}
                    placeholder="Section"
                    className={"sectionName-" + venueEventKey}
                />
                <br />
                <Button 
                    fillMode="link" 
                    type={"button"} 
                    className="smallLinkButton ps-0 pb-0"
                    onClick={() => viewEventAlerts(venueEventKey, ticketingWebsiteId)}>View event alerts</Button>
                
                {eventTicketTypes && eventTicketTypes.length > 0 && 
                    <>
                        <br />
                        <Button 
                            fillMode="link" 
                            type={"button"} 
                            className="smallLinkButton ps-0 pb-0"
                            onClick={() => viewTicketTypes(eventTicketTypes)}>View ticket types</Button>
                    </>
                }
            </td>
        );
    };

    const CostCell = (props) => {
        //Use the custom hook to disable scrolling in number inputs
        useDisableNumberInputScroll();

        const venueEventKey = props.dataItem.venueEventKey;
        const cost = props.dataItem.cost;

        return (
            <td>
                <NumericTextBox
                    onChange={(event) => eventCostChanged(venueEventKey, event.value)}
                    value={cost}
                    placeholder="Cost"
                    spinners={false}
                    width={90}
                    min={1}
                    max={10000}
                    className={"cost-" + venueEventKey}
                />
            </td>
        );
    };

    const PriceCell = (props) => {
        //Use the custom hook to disable scrolling in number inputs
        useDisableNumberInputScroll();

        const venueEventKey = props.dataItem.venueEventKey;
        const price = props.dataItem.price;

        return (
            <td>
                <NumericTextBox
                    onChange={(event) => eventPriceChanged(venueEventKey, event.value)}
                    value={price}
                    placeholder="Price"
                    spinners={false}
                    width={90}
                    min={1}
                    max={10000}
                    className={"price-" + venueEventKey}
                />
            </td>
        );
    };

    const eventNameValidator = (value) => {
        if (!value) {
            return "";
        }

        if (value.length > 50) {
            return "Maximum length is 50 characters";
        }

        return "";
    }

    const viewSelectedUrls = () => {
        if (eventsNotShorted.length === 0) {
            addNotificationWithTimeout(dispatch, "error", "No websites to view");
            return;
        }

        let count = 0;

        eventsNotShorted.forEach(dataItem => {
            if (dataItem.selected === true) {
                count++;
                window.open(dataItem.ticketingUrl, "_blank", "noreferrer");
            }            
        });

        if (count === 0) {
            addNotificationWithTimeout(dispatch, "error", "No websites to view");
            return;
        }
    };

    const viewTicketTypes = (eventTicketTypes) => {
        setTicketTypes(eventTicketTypes);
        setShowTicketTypes(true);
    };

    const viewEventAlerts = (eventKey, ticketingWebsiteId) => {
        setAlertsEventKey(eventKey);
        setAlertsTicketingWebsiteId(ticketingWebsiteId);
        setShowEventAlerts(true);
    };

    const getTicketingWebsites = () => {
        const dataItem = {
            onlyActive: true,
        }

        fetch(`/api/general/ticketingwebsites`,
            {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    "X-XSRF-TOKEN": getCSRFToken(),
                },
                body: JSON.stringify(dataItem),
            })
            .then(handleResponse)
            .then(result => {
                const allTicketingWebsites = [defaultTicketingWebsite].concat(result);
                setTicketingWebsites(allTicketingWebsites);
            })
            .catch(error => {
                addNotificationWithTimeout(dispatch, "error", error.message);
            });
    }

    const getVenueEventStatusTypes = () => {
        fetch(`/api/general/venueeventstatustypes`,
            {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    "X-XSRF-TOKEN": getCSRFToken(),
                },
                body: JSON.stringify({}),
            })
            .then(handleResponse)
            .then(result => {
                const allVenueEventStatusTypes = [defaultVenueEventStatusType].concat(result);
                setVenueEventStatusTypes(allVenueEventStatusTypes);
            })
            .catch(error => {
                addNotificationWithTimeout(dispatch, "error", error.message);
            });
    }

    const getLoginShortingDefaultSettings = () => {
        fetch(`/api/administrator/getloginshortingdefaultsettings`,
            {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    "X-XSRF-TOKEN": getCSRFToken(),
                },
                body: JSON.stringify({}),
            })
            .then(handleResponse)
            .then(result => {
                if (result.shortingDefaultLowSeatNumber) {
                    setEnteredLowSeatNumber(result.shortingDefaultLowSeatNumber);
                }
            })
            .catch(error => {
                addNotificationWithTimeout(dispatch, "error", error.message);
            });
    }

    const venueChanged = (event) => {
        const value = event.value;

        clearTimeout(autocompleteTimeout.current);

        if (!value || value.length < 2) {
            setVenues([]);
            setAreVenuesLoading(false);
            setVenueName(null);
            return;
        }
        
        autocompleteTimeout.current = setTimeout(() => {
            const dataItem = {
                name: value,
                onlyActive: true,
            };

            fetch(`/api/administrator/venues`,
                {
                    method: "POST",
                    headers: {
                        'Content-Type': 'application/json',
                        "X-XSRF-TOKEN": getCSRFToken(),
                    },
                    body: JSON.stringify(dataItem),
                })
                .then(handleResponse)
                .then(result => {
                    setVenues(result.venues);  
                    setVenueName(value);
                })
                .catch(error => {
                    addNotificationWithTimeout(dispatch, "error", error.message);
                })
                .finally(() => {
                    setAreVenuesLoading(false);
                });
        }, timeoutDelay);

        setAreVenuesLoading(true);
    };

    const getEventsNotShorted = (dataItem, newPageNumber) => {
        setFocusElementClassName(undefined);
        setAreEventsNotShortedLoading(true);

        if (!dataItem) {
            dataItem = searchCriteria;
        }

        if (!dataItem) {
            dataItem = { };
        }

        dataItem.pageNumber = newPageNumber;
    
        fetch(`/api/administrator/pos/eventsnotshorted`,
            {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    "X-XSRF-TOKEN": getCSRFToken(),
                },
                body: JSON.stringify(dataItem),
            })
            .then(handleResponse)
            .then(result => {
                setReportId(result.reportId);
                setItemsPerPage(result.itemsPerPage);
                setSkipCount(result.itemsPerPage * (result.pageNumber - 1));
                setEventsNotShortedCount(result.totalCount);    

                let eventsNotShortedCopy = result.eventsNotShorted;
                
                eventsNotShortedCopy.forEach(dataItem => {
                    dataItem.selected = false;
                });

                setEventsNotShorted(eventsNotShortedCopy);
                setIsHeaderCheckboxChecked(false);
                setLastSelectedVenueEventKey(undefined);
            })
            .catch(error => {
                addNotificationWithTimeout(dispatch, "error", error.message);                
            })
            .finally(() => {
                setAreEventsNotShortedLoading(false);
            });
    }

    const hideEvents = (venueEventKeys) => {
        if (window.confirm("Are you sure you want to permanently hide these events from this report?") === false) {
            return;
        }

        setFocusElementClassName(undefined);
        setAreEventsNotShortedLoading(true);

        const dataItem = {
            venueEventKeys: venueEventKeys,
            reportId: reportId,
        };
    
        fetch("/api/general/hidevenueeventsfromreport",
            {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    "X-XSRF-TOKEN": getCSRFToken(),
                },
                body: JSON.stringify(dataItem),
            })
            .then(handleResponse)
            .then(result => {
                addNotificationWithTimeout(dispatch, "success", "Permanently hid events from report");     
                
                getEventsNotShorted();
            })
            .catch(error => {
                addNotificationWithTimeout(dispatch, "error", error.message);
                
                setAreEventsNotShortedLoading(false);
            });
    };

    const temporarilyHideEvents = (venueEventKeys) => {
        if (window.confirm("Are you sure you want to temporarily hide these events from this report?") === false) {
            return;
        }

        if (!selectedStopHidingDate) {
            addNotificationWithTimeout(dispatch, "error", "You must select a stop hiding date");
            return;
        }

        const day = selectedStopHidingDate.getDate();
        const month = selectedStopHidingDate.getMonth() + 1;
        const year = selectedStopHidingDate.getFullYear();
        const stopHidingDate = `${month}/${day}/${year}`;

        setFocusElementClassName(undefined);
        setAreEventsNotShortedLoading(true);

        const dataItem = {
            venueEventKeys: venueEventKeys,
            reportId: reportId,
            stopHidingDate: stopHidingDate,
        };

        fetch("/api/general/temporarilyhidevenueeventsfromreport",
            {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    "X-XSRF-TOKEN": getCSRFToken(),
                },
                body: JSON.stringify(dataItem),
            })
            .then(handleResponse)
            .then(result => {
                addNotificationWithTimeout(dispatch, "success", "Temporarily hid events from report");

                getEventsNotShorted();
            })
            .catch(error => {
                addNotificationWithTimeout(dispatch, "error", error.message);

                setAreEventsNotShortedLoading(false);
            });
    };

    const hideSelectedEvents = () => {
        let venueEventKeys = [];

        eventsNotShorted.forEach(dataItem => {
            if (dataItem.selected === true) {
                venueEventKeys.push(dataItem.venueEventKey);
            }
        });  

        if (venueEventKeys.length === 0) {
            addNotificationWithTimeout(dispatch, "error", "No events selected");   
            return;
        }

        hideEvents(venueEventKeys);
    };

    const temporarilyHideSelectedEvents = () => {
        let venueEventKeys = [];

        eventsNotShorted.forEach(dataItem => {
            if (dataItem.selected === true) {
                venueEventKeys.push(dataItem.venueEventKey);
            }
        });

        if (venueEventKeys.length === 0) {
            addNotificationWithTimeout(dispatch, "error", "No events selected");
            return;
        }

        temporarilyHideEvents(venueEventKeys);
    };

    const getData = (dataItem) => {
        if (dataItem.ticketingWebsite !== undefined
            && dataItem.ticketingWebsite.value !== "") {
            dataItem.ticketingWebsiteId = parseInt(dataItem.ticketingWebsite.ticketingWebsiteId);
        }
        else {
            dataItem.ticketingWebsiteId = undefined;
        }

        if (dataItem.venueEventStatusType !== undefined
            && dataItem.venueEventStatusType.value !== "") {
            dataItem.venueEventStatusTypeId = parseInt(dataItem.venueEventStatusType.venueEventStatusTypeId);
        }
        else {
            dataItem.venueEventStatusTypeId = undefined;
        }

        dataItem.venueKey = undefined;
        if (venues.length > 0) {
            const venue = venues.find(element => element.currentName === venueName);

            if (venue) {
                dataItem.venueKey = venue.venueKey;
            }
        }

        dataItem.startingEventDate = undefined;
        dataItem.endingEventDate = undefined;
        if (dataItem.eventDates) {
            if (dataItem.eventDates.start) {
                dataItem.startingEventDate = `${dataItem.eventDates.start.getMonth() + 1}/${dataItem.eventDates.start.getDate()}/${dataItem.eventDates.start.getFullYear()}`;
            }

            if (dataItem.eventDates.end) {
                dataItem.endingEventDate = `${dataItem.eventDates.end.getMonth() + 1}/${dataItem.eventDates.end.getDate()}/${dataItem.eventDates.end.getFullYear()}`;
            }
        }
        
        setSearchCriteria(dataItem);
        getEventsNotShorted(dataItem);
    }

    const pageChange = (event) => {
        const newPageNumber = (event.page.skip / event.page.take) + 1;
        getEventsNotShorted(null, newPageNumber);
    };

    const selectedValueChanged = (event, venueEventKey, selected) => {
        setFocusElementClassName(undefined);
        setAreEventsNotShortedLoading(true);
        
        setTimeout(() => { 
            let eventsNotShortedCopy = eventsNotShorted;

            const itemIndex = eventsNotShortedCopy.findIndex(dataItem =>
                dataItem.venueEventKey === venueEventKey
            );

            let isSelectingMultipleItems = false;

            //Shift selection of multiple items            
            if (event.nativeEvent.shiftKey
                && lastSelectedVenueEventKey !== undefined
                && lastSelectedVenueEventKey !== venueEventKey) {
                const lastSelectedItemIndex = eventsNotShortedCopy.findIndex(dataItem =>
                    dataItem.venueEventKey === lastSelectedVenueEventKey
                );

                if (lastSelectedItemIndex >= 0) {
                    isSelectingMultipleItems = true;

                    let lowIndex = -1;
                    let highIndex = -1;

                    if (itemIndex > lastSelectedItemIndex) {
                        lowIndex = lastSelectedItemIndex;
                        highIndex = itemIndex;
                    }
                    else {
                        lowIndex = itemIndex;
                        highIndex = lastSelectedItemIndex;
                    }

                    for (let i = lowIndex; i <= highIndex; i++) {
                        eventsNotShortedCopy[i].selected = selected;
                    }
                }
            }

            if (isSelectingMultipleItems === false) {
                eventsNotShortedCopy[itemIndex].selected = selected;
            }

            if (selected === true) {
                setLastSelectedVenueEventKey(venueEventKey);
            }

            setEventsNotShorted(eventsNotShortedCopy);

            setIsHeaderCheckboxChecked(false);
            setAreEventsNotShortedLoading(false);
        }, 1);  
    };

    const headerCheckboxValueChanged = () => {
        setFocusElementClassName(undefined);
        setAreEventsNotShortedLoading(true);
        
        setTimeout(() => { 
            const checked = !isHeaderCheckboxChecked;
            setIsHeaderCheckboxChecked(checked);

            let eventsNotShortedCopy = eventsNotShorted;
        
            eventsNotShortedCopy.forEach(dataItem =>
                dataItem.selected = checked
            );        

            setEventsNotShorted(eventsNotShortedCopy);

            setLastSelectedVenueEventKey(undefined);

            setAreEventsNotShortedLoading(false);
        }, 1);        
    };

    const eventSectionNameChanged = (venueEventKey, sectionName) => {
        setAreEventsNotShortedLoading(true);

        setTimeout(() => {
            let eventsNotShortedCopy = eventsNotShorted;

            const itemIndex = eventsNotShortedCopy.findIndex(dataItem =>
                dataItem.venueEventKey === venueEventKey
            );
            eventsNotShortedCopy[itemIndex].sectionName = sectionName;

            setEventsNotShorted(eventsNotShortedCopy);

            setFocusElementClassName(`.sectionName-${venueEventKey}`);

            setAreEventsNotShortedLoading(false);
        }, 1); 
    };

    const eventCostChanged = (venueEventKey, cost) => {
        setAreEventsNotShortedLoading(true);

        setTimeout(() => {
            let eventsNotShortedCopy = eventsNotShorted;

            const itemIndex = eventsNotShortedCopy.findIndex(dataItem =>
                dataItem.venueEventKey === venueEventKey
            );
            eventsNotShortedCopy[itemIndex].cost = cost;

            setEventsNotShorted(eventsNotShortedCopy);

            setFocusElementClassName(`.cost-${venueEventKey} > input`);

            setAreEventsNotShortedLoading(false);
        }, 1); 
    };

    const eventPriceChanged = (venueEventKey, price) => {
        setAreEventsNotShortedLoading(true);

        setTimeout(() => {
            let eventsNotShortedCopy = eventsNotShorted;

            const itemIndex = eventsNotShortedCopy.findIndex(dataItem =>
                dataItem.venueEventKey === venueEventKey
            );
            eventsNotShortedCopy[itemIndex].price = price;

            setEventsNotShorted(eventsNotShortedCopy);

            setFocusElementClassName(`.price-${venueEventKey} > input`);

            setAreEventsNotShortedLoading(false);
        }, 1); 
    };

    const quantityChanged = (event) => {
        setSelectedQuantity(event.target.value);
    };

    const sectionNameChanged = (event) => {
        setEnteredSectionName(event.value);
    };

    const lowSeatNumberChanged = (event) => {
        setEnteredLowSeatNumber(event.value);
    };

    const createInventory = () => {
        if (!enteredSectionName) {
            addNotificationWithTimeout(dispatch, "error", "You must enter a section name.");   
            return;
        }

        if (selectedQuantity.value === 0) {
            addNotificationWithTimeout(dispatch, "error", "You must select a quantity.");   
            return;
        }

        let venueEvents = [];

        eventsNotShorted.forEach(dataItem => {
            if (dataItem.selected === true) {
                venueEvents.push({
                    venueEventKey: dataItem.venueEventKey,
                    sectionName: dataItem.sectionName,
                    cost: dataItem.cost,
                    price: dataItem.price
                });
            }
        });  

        if (venueEvents.length === 0) {
            addNotificationWithTimeout(dispatch, "error", "No events selected");   
            return;
        }

        const ticketQuantity = selectedQuantity.value;

        if (ticketQuantity > defaultQuantity) {
            if (window.confirm(`Are you sure you want to short ${ticketQuantity} tickets for these events?`) === false) {
                return;
            }
        }
        else if (window.confirm("Are you sure you want to short these events?") === false) {
            return;
        }

        setFocusElementClassName(undefined);
        setAreEventsNotShortedLoading(true);

        const dataItem = {
            venueEvents: venueEvents,
            sectionName: enteredSectionName,
            quantity: ticketQuantity,
            lowSeatNumber: enteredLowSeatNumber,
        };
    
        fetch(`/api/administrator/pos/shortevents`,
            {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    "X-XSRF-TOKEN": getCSRFToken(),
                },
                body: JSON.stringify(dataItem),
            })
            .then(handleResponse)
            .then(result => {
                addNotificationWithTimeout(dispatch, "success", "Shorted events successfully");     
                
                getEventsNotShorted();
            })
            .catch(error => {
                addNotificationWithTimeout(dispatch, "error", error.message);   
                
                setAreEventsNotShortedLoading(false);
            });
    };

    const stopHidingDateChanged = (event) => {
        setSelectedStopHidingDate(event.target.value);
    };

    useEffect(() => {
        document.title = "Events Not Shorted";

        getTicketingWebsites();
        getVenueEventStatusTypes();
        getLoginShortingDefaultSettings();

        const nextSaturday = GetNextSaturday();
        setSelectedStopHidingDate(nextSaturday);
    }, []);

    useEffect(() => {
        if (focusElementClassName) {
            const element = document.querySelector(focusElementClassName);

            if (element) {
                element.focus();                            
            }
        }
    }, [areEventsNotShortedLoading]);

    return (
        <div className="administratorReport">
            <Form
                onSubmit={getData}
                ignoreModified={true}
                ref={formReference}
                render={(formRenderProps) => (
                    <FormElement>
                        <fieldset className={"k-form-fieldset container"}>
                            <div className="row"> 
                                <div className="col-12">
                                    <Field
                                        id={"onlyEventsWithTaxesAndFees"}
                                        name={"onlyEventsWithTaxesAndFees"}
                                        label={"Only show events where the tickets types have taxes and fees"}
                                        component={FormCheckbox}
                                        defaultValue={false}
                                    />
                                </div>
                                <div className="col-12">
                                    <Field
                                        id={"onlyEventsWithAlerts"}
                                        name={"onlyEventsWithAlerts"}
                                        label={"Only show events with alerts"}
                                        component={FormCheckbox}
                                        defaultValue={false}
                                    />
                                </div>
                                <div className="col-md-4">
                                    <Field
                                        id={"ticketingWebsite"}
                                        name={"ticketingWebsite"}
                                        label={"Ticketing website"}
                                        component={FormDropDownList}
                                        data={ticketingWebsites}
                                        textField="name"
                                        dataItemKey="ticketingWebsiteId"
                                        defaultValue={ticketingWebsites.find(element => element.ticketingWebsiteId === "")}
                                    /> 
                                </div>
                                <div className="col-md-4">
                                    <Field
                                        id={"venueName"}
                                        name={"venueName"}
                                        label={"Venue"}
                                        component={FormAutoComplete}
                                        data={venues}        
                                        placeholder="e.g. Roseland"
                                        textField="currentName"
                                        onChange={venueChanged}
                                        loading={areVenuesLoading}
                                    />
                                </div>
                                <div className="col-md-4">
                                    <Field
                                        id={"eventName"}
                                        name={"eventName"}
                                        label={"Event name"}
                                        component={FormInput}
                                        validator={eventNameValidator}
                                    />
                                </div>
                                <div className="col-md-4">
                                    <Field
                                        id={"venueEventStatusType"}
                                        name={"venueEventStatusType"}
                                        label={"Event status"}
                                        component={FormDropDownList}
                                        data={venueEventStatusTypes}
                                        textField="name"
                                        dataItemKey="venueEventStatusTypeId"
                                        defaultValue={venueEventStatusTypes.find(element => element.venueEventStatusTypeId === "")}
                                    /> 
                                </div>                                
                                <div className="col-md-6">
                                    <Field
                                        id={"eventDates"}
                                        name={"eventDates"}
                                        component={FormDateRangePicker}
                                        format={"MMM dd, yyyy"}
                                        startDateInputSettings={{
                                            label: "Starting event date"
                                        }}
                                        endDateInputSettings={{
                                            label: "Ending event date"
                                        }}                                        
                                        calendarSettings={{
                                            views: 1
                                        }}
                                    />
                                </div> 
                                <div className="col-md-2">
                                    <div className="k-form-field">
                                        <label className="k-label">&nbsp;</label>
                                        <Button
                                            type={"submit"}
                                            themeColor={"primary"}
                                            icon="search"                                            
                                        >
                                            Search
                                        </Button>
                                    </div>
                                </div>
                            </div>                        
                        </fieldset>
                    </FormElement>
                )}
            />

            {areEventsNotShortedLoading ? <LoadingPanel /> : <></> }

            {!eventsNotShorted ? <></> :
                <>                    
                    <div className="mb-3 ms-2 d-flex flex-row">
                        <div className="p-2 me-2 border">
                            <Button type={"button"} icon="close" title="Permanently Hide Selected Events" onClick={hideSelectedEvents}>
                                Permanently Hide Selected Events
                            </Button>
                        </div>
                        <div className="p-2 border d-flex flex-row">
                            <div className="me-2">
                                <DatePicker
                                    id="stopHidingDate"
                                    placeholder="Stop hiding date"
                                    value={selectedStopHidingDate}
                                    onChange={stopHidingDateChanged}
                                />
                            </div>
                            <div>
                                <Button type={"button"} icon="clock" title="Temporarily Hide Selected Events" onClick={temporarilyHideSelectedEvents}>
                                    Temporarily Hide Selected Events
                                </Button>
                            </div>
                        </div>
                    </div>
                    
                    <div className="mb-3 ms-2 d-flex flex-row">
                        <div class="p-2 border d-flex flex-row">
                            <div className="me-2">
                                <Input
                                    id={"sectionName"}
                                    placeholder="Section name"
                                    onChange={sectionNameChanged}
                                    value={enteredSectionName} />
                            </div>
                            <div className="me-2">
                                <NumericTextBox
                                    id={"lowSeatNumber"}
                                    placeholder="Low seat"
                                    onChange={lowSeatNumberChanged}
                                    value={enteredLowSeatNumber}
                                    spinners={false}
                                    format="n0"
                                    width={90}
                                    min={1}
                                    max={2000000000} />
                            </div>
                            <div className="me-2">
                                <DropDownList
                                    id="quantity"
                                    textField="name"
                                    dataItemKey="value"
                                    data={quantities}
                                    value={selectedQuantity}
                                    onChange={quantityChanged}
                                />
                            </div>
                            <div>
                                <Button
                                    themeColor="primary"
                                    type={"button"}
                                    icon="plus"
                                    title="Short Events"
                                    onClick={createInventory}>
                                    Short Events
                                </Button>
                            </div>
                        </div>
                    </div>

                    <Grid
                        data={eventsNotShorted}
                        resizable={true}
                        skip={skipCount}
                        take={itemsPerPage}
                        total={eventsNotShortedCount}
                        pageable={true}
                        onPageChange={pageChange}
                        scrollable="none"
                        dataItemKey="venueEventKey"
                    >
                        <Column cell={SelectedCell} headerCell={SelectedHeaderCell} />
                        <Column field="ticketingUrl" cell={ViewUrlCell} headerCell={ViewUrlHeaderCell} />
                        <Column field="sectionName" title={"Section"} cell={SectionNameCell} />
                        <Column field="cost" title={"Cost"} cell={CostCell} />
                        <Column field="price" title={"Price"} cell={PriceCell} />
                        <Column field="ticketingWebsiteName" title={"Website"} />
                        <Column field="eventName" title={"Event"} />
                        <Column field="venueName" title={"Venue"} />
                        <Column field="eventDate" title={"Date"} />
                        <Column field="venueEventStatusTypeName" title={"Status"} />
                    </Grid>

                    {showTicketTypes === false ? <></> :
                        <Dialog
                            title="Ticket Types"
                            onClose={() => setShowTicketTypes(false)}
                            width={"90vw"}
                        >
                            <Grid
                                data={ticketTypes}
                                resizable={true}
                                scrollable="none"
                            >
                                <Column field="name" title={"Name"} />
                                <Column field="status" title={"Status"} />
                                <Column field="price" title={"Price"} format="{0:c}" />
                                <Column field="taxesAndFees" title={"Fees"} format="{0:c}" />
                                <Column field="orderFee" title={"Order Fee"} format="{0:c}" />
                                <Column field="priceCurrencyCode" title={"Currency"} />
                                <Column field="purchaseTicketLimit" title={"Limit"} className="text-center" />
                                <Column field="minimumAge" title={"Min Age"} className="text-center" />
                                <Column field="capacity" title={"Capacity"} className="text-center" />
                                <Column field="isGeneralAdmission" title={"GA?"} />
                            </Grid>
                        </Dialog>
                    }

                    {showEventAlerts === false ? <></> :
                        <Dialog
                            title="Event Alerts"
                            onClose={() => setShowEventAlerts(false)}
                            width={"90vw"}
                        >
                            <AdministratorVenueEventAlerts venueEventKey={alertsEventKey} ticketingWebsiteId={alertsTicketingWebsiteId} />
                        </Dialog>
                    }
                </>
            }
        </div>
    );
}